import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../../features/auth';
import { Link, useNavigate } from 'react-router-dom';
import icons from '../../../shared/lib/icons';
import { AppDecorBackground } from '../../../shared/ui';
import {theme} from '../../../shared/lib/styles';

const Layout = ({ children }) => {
    const { user, logout } = useAuth();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuRef = useRef(null);
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        setIsMenuOpen(false);
        navigate('/login');
    };

    const toggleMenu = () => setIsMenuOpen((open) => !open);
    const closeMenu = () => setIsMenuOpen(false);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isMenuOpen && menuRef.current && !menuRef.current.contains(event.target)) {
                setIsMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isMenuOpen]);

    return (
        <div style={styles.container}>
            <AppDecorBackground />
            <div style={styles.content}>
            <header style={styles.header}>
                <Link to="/dashboard" style={styles.titleLink}>
                    <h1 style={styles.title}>Ландграф</h1>
                </Link>
                <div style={styles.userControls}>
                    <span style={styles.username}>Привет, {user?.username || 'Пользователь'}!</span>
                    <div style={styles.userMenu} ref={menuRef}>
                        <button type="button" onClick={toggleMenu} style={styles.menuButton}>
                            {icons.profile}
                        </button>
                        {isMenuOpen && (
                            <div style={styles.dropdownMenu}>
                                <Link
                                    to="/playlists"
                                    style={styles.dropdownItem}
                                    onClick={closeMenu}
                                >
                                    Мои плейлисты
                                </Link>
                                <Link
                                    to="/settings"
                                    style={styles.dropdownItem}
                                    onClick={closeMenu}
                                >
                                    Настройки
                                </Link>
                                <button
                                    type="button"
                                    onClick={handleLogout}
                                    style={{ ...styles.dropdownItem, background: 'none', border: 'none', textAlign: 'left' }}
                                >
                                    Выход
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </header>

            <main style={styles.main}>
                {children}
            </main>

            <footer style={styles.footer}>
                <p>© {new Date().getFullYear()} Landgraf. Все права защищены.</p>
            </footer>
            </div>
        </div>
    );
};

const styles = {
    container: {
        position: 'relative',
        minHeight: '100vh',
        backgroundColor: 'transparent',
    },
    content: {
        position: 'relative',
        zIndex: 1,
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: `${theme.spacing.lg} ${theme.spacing.xl}`,
        backgroundColor: 'rgba(245, 235, 214, 0.88)',
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        boxShadow: theme.shadows.md,
        borderBottom: `1px solid ${theme.colors.borderLight}`,
    },
    title: {
        margin: 0,
        fontSize: theme.fontSize['3xl'],
        fontWeight: theme.fontWeight.bold,
        color: theme.colors.brandTeal,
    },
    titleLink: {
        textDecoration: 'none',
        cursor: 'pointer',
    },
    userControls: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing.md,
    },
    username: {
        fontSize: theme.fontSize.base,
        color: theme.colors.textSecondary,
    },
    userMenu: {
        position: 'relative',
        display: 'inline-block',
    },
    menuButton: {
        padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
        backgroundColor: theme.colors.bgTertiary,
        color: theme.colors.textPrimary,
        border: `1px solid ${theme.colors.borderLight}`,
        borderRadius: theme.borderRadius.md,
        cursor: 'pointer',
        fontSize: theme.fontSize.sm,
        fontWeight: theme.fontWeight.semibold,
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing.xs,
        transition: `background-color ${theme.transitions.default}, border-color ${theme.transitions.default}`,
    },
    dropdownMenu: {
        position: 'absolute',
        top: '100%',
        right: 0,
        marginTop: theme.spacing.xs,
        backgroundColor: theme.colors.bgPrimary,
        boxShadow: theme.shadows.xl,
        borderRadius: theme.borderRadius.lg,
        minWidth: '160px',
        zIndex: 1000,
        overflow: 'hidden',
    },
    dropdownItem: {
        display: 'block',
        padding: `${theme.spacing.sm} ${theme.spacing.md}`,
        color: theme.colors.textPrimary,
        textDecoration: 'none',
        fontSize: theme.fontSize.sm,
        transition: `background-color ${theme.transitions.default}`,
        cursor: 'pointer',
        width: '100%',
        textAlign: 'left',
        background: 'none',
        border: 'none',
    },
    main: {
        padding: theme.spacing.xl,
        flex: 1,
    },
    footer: {
        textAlign: 'center',
        padding: theme.spacing.lg,
        color: theme.colors.textTertiary,
        fontSize: theme.fontSize.sm,
        borderTop: `1px solid ${theme.colors.borderLight}`,
        backgroundColor: 'rgba(245, 235, 214, 0.75)',
    },
};

export default Layout;
